// This file is auto-generated by @hey-api/openapi-ts

import { formDataBodySerializer, type RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { DeleteUsingPost1Data, DeleteUsingPost1Errors, DeleteUsingPost1Responses, EraseStatusUsingGetData, EraseStatusUsingGetErrors, EraseStatusUsingGetResponses, HistoryUsingGet1Data, HistoryUsingGet1Errors, HistoryUsingGet1Responses, LinkUsingPostData, LinkUsingPostErrors, LinkUsingPostResponses, UploadUsingPostData, UploadUsingPostErrors, UploadUsingPostResponses } from '../types.gen';

export class DesktopCaptionEraseControllerService {
    /**
     * link
     */
    public static linkUsingPost<ThrowOnError extends boolean = false>(options?: Options<LinkUsingPostData, ThrowOnError>): RequestResult<LinkUsingPostResponses, LinkUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<LinkUsingPostResponses, LinkUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/caption/erase',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * delete
     */
    public static deleteUsingPost1<ThrowOnError extends boolean = false>(options: Options<DeleteUsingPost1Data, ThrowOnError>): RequestResult<DeleteUsingPost1Responses, DeleteUsingPost1Errors, ThrowOnError> {
        return (options.client ?? client).post<DeleteUsingPost1Responses, DeleteUsingPost1Errors, ThrowOnError>({ url: '/v1/desktop/caption/erase/delete', ...options });
    }
    
    /**
     * history
     */
    public static historyUsingGet1<ThrowOnError extends boolean = false>(options?: Options<HistoryUsingGet1Data, ThrowOnError>): RequestResult<HistoryUsingGet1Responses, HistoryUsingGet1Errors, ThrowOnError> {
        return (options?.client ?? client).get<HistoryUsingGet1Responses, HistoryUsingGet1Errors, ThrowOnError>({ url: '/v1/desktop/caption/erase/history', ...options });
    }
    
    /**
     * eraseStatus
     */
    public static eraseStatusUsingGet<ThrowOnError extends boolean = false>(options: Options<EraseStatusUsingGetData, ThrowOnError>): RequestResult<EraseStatusUsingGetResponses, EraseStatusUsingGetErrors, ThrowOnError> {
        return (options.client ?? client).get<EraseStatusUsingGetResponses, EraseStatusUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/caption/erase/status', ...options });
    }
    
    /**
     * upload
     */
    public static uploadUsingPost<ThrowOnError extends boolean = false>(options?: Options<UploadUsingPostData, ThrowOnError>): RequestResult<UploadUsingPostResponses, UploadUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<UploadUsingPostResponses, UploadUsingPostErrors, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/v1/desktop/caption/erase/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options?.headers
            }
        });
    }
}
